export const SET_SHOW_BUG_REPORT_FORM = 'general/SHOW_BUG_REPORT_FORM';

export const setShowBugReportForm = (showBugReportForm: boolean) => ({
  type: SET_SHOW_BUG_REPORT_FORM,
  showBugReportForm,
});
